import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "break-word" }

import { computed } from 'vue'
import { IntervalType } from '@/shared/ui/SogScheduleSerie/types/IntervalType'
import type ScheduleSerieDefinition from '@/shared/ui/SogScheduleSerie/types/ScheduleSerieDefinition'
import { DayType } from '@/shared/ui/SogScheduleSerie/types/DayType'

interface Props {
  value?: ScheduleSerieDefinition
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogScheduleSerieLabel',
  props: {
    value: { default: undefined }
  },
  setup(__props: any) {

const props = __props

const t_text = computed(() => {
  if (props.value) {
    switch (props.value.intervalType) {
      case IntervalType.None:
        return 'Keine Serie ausgewählt'

      case IntervalType.Minutely:
        return `alle ${props.value.interval} ${props.value.interval === 1 ? 'Minute' : 'Minuten'}`

      case IntervalType.Daily:
        return p_getDaily()

      default:
        return props.value.intervalType
    }
  }
  return ''
})

function p_getDaily() {
  switch (props.value?.dayType) {
    case DayType.All:
      if (props.value?.interval === 1) {
        return `Täglich um ${props.value.time?.slice(0, 5)} Uhr`
      }
      return `Täglich, alle ${props.value.interval} Tage um ${props.value.time?.slice(0, 5)} Uhr`

    case DayType.WorkingDayOnly:
      if (props.value?.interval === 1) {
        return `Täglich, jeden Arbeitstag um ${props.value.time?.slice(0, 5)} Uhr`
      }
      return `Täglich, alle ${props.value.interval} Arbeitstage um ${props.value.time?.slice(0, 5)} Uhr`

    case DayType.WorkingDay:
      if (props.value?.interval === 1) {
        return `Täglich, jeden Arbeitstag um ${props.value.time?.slice(0, 5)} Uhr`
      }
      return `Täglich, alle ${props.value.interval} Tage, Termin am Arbeitstag um ${props.value.time?.slice(0, 5)} Uhr`
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(t_text.value), 1))
}
}

})